/**
 * Colors for APIs that cannot read CSS variables (QR props, inline AR styles,
 * smoke seeds, demo data). ! Keep in sync with app/theme.css --qr-*, --ar-*,
 * --studio-*, --top-loader-*, and demo hex values.
 */

/** Studio 3D viewer — background, ground plane, grid line colors */
export const THREE_MUTED_BACKGROUND_LIGHT = 0xd4d4d4;
export const THREE_GROUND_LIGHT = 0xe2e2e2;
export const THREE_GRID_LIGHT = 0xb8b8b8;

export const THREE_MUTED_BACKGROUND_DARK = 0x262626;
export const THREE_GROUND_DARK = 0x2e2e2e;
export const THREE_GRID_DARK = 0x3c3c3c;

/** Studio 3D viewer — radial backdrop center (lighter pool of light behind product) */
export const THREE_STUDIO_BG_CENTER_LIGHT = 0xf0f0f0;
export const THREE_STUDIO_BG_CENTER_DARK = 0x383838;

export const STUDIO_DEFAULT_BACKGROUND = "#ffffff";
export const STUDIO_DEFAULT_PANEL = "#f5f5f5";

export const QR_BRAND_BG = "#ffffff";
export const QR_BRAND_FG = "#3d2b1f";

export const AR_VIEWPORT_BG = "#000000";
export const AR_CONTROL_BG = "#5a3e28";
export const AR_CONTROL_FG = "#ffffff";
export const AR_OVERLAY_FG = "#ffffff";
export const AR_SPINNER_TOP = "#ffffff";
export const AR_CARD_BG = "#ffffff";

export const TOP_LOADER_MARKETING_LIGHT = "#5d4a36";
export const TOP_LOADER_MARKETING_DARK = "#c1a68b";
export const TOP_LOADER_APP_LIGHT = "#fafafa";
export const TOP_LOADER_APP_DARK = "#7a6d5f";

/** Smoke test folder color — matches --folder-default-swatch / grey-900 */
export const FOLDER_DEFAULT_SWATCH = "#111827";

/** Interactive studio demo material chips (marketing) */
export const DEMO_STUDIO_MATERIALS = {
  kraft: "#d4a574",
  white: "#f5f5f5",
  black: "#2c3e50",
  blue: "#0f4c81",
  accent: "#c9b8a0",
} as const;
